<template>
  <section>
    <div class="container pt-5 pb-5">
      <div class="columns">
        <div class="column is-6">
          <h1 class="title is-4 mb-0 has-text-primary has-text-centered-mobile">
            <span class="icon">
              <i class="mdi mdi-checkbox-marked-circle-outline"></i>
            </span>
            <span>CONFIRMACIÓN DE PEDIDO</span>
          </h1>
        </div>
        <div class="column is-6 has-text-right has-text-centered-mobile"></div>
      </div>

      <section v-if="order">
        <!-- Datos de Contacto -->

        <div class="card">
          <div class="card-content">
            <div class="columns is-vcentered">
              <div class="column is-3 has-background-light">
                <div class="p-5 is-size-5 has-text-centered">
                  <span class="icon"><i class="mdi mdi-account"></i></span>
                  <span><b>Datos de Contacto</b></span>
                </div>
              </div>
              <div class="column">
                <table class="table is-fullwidth">
                  <tbody>
                    <tr>
                      <td
                        style="width: 50%"
                        class="has-background-light has-text-primary"
                      >
                        <b>Nombre completo</b>
                      </td>
                      <td>{{ order.holder_name }}</td>
                    </tr>

                    <tr>
                      <td
                        style="width: 50%"
                        class="has-background-light has-text-primary"
                      >
                        <b>Teléfono de contacto</b>
                      </td>
                      <td>{{ order.holder.phone }}</td>
                    </tr>

                    <tr>
                      <td
                        style="width: 50%"
                        class="has-background-light has-text-primary"
                      >
                        <b>Correo de contacto</b>
                      </td>
                      <td>{{ order.holder.email }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>

        <!-- Dirección -->
        <div class="card" v-if="order.shipping_method === 'standard'">
          <div class="card-content">
            <div class="columns">
              <div class="column is-3 has-background-light">
                <div class="p-5 is-size-5 has-text-centered">
                  <span class="icon"><i class="mdi mdi-map-marker"></i></span>
                  <span><b>Dirección de Envío</b></span>
                </div>
              </div>
              <div class="column">
                <table class="table is-fullwidth">
                  <tbody>
                    <tr>
                      <td
                        style="width: 50%"
                        class="has-background-light has-text-primary"
                      >
                        <b>Calle y Número</b>
                      </td>
                      <td>
                        {{ default_address.street }} {{ default_address.ext }}
                        {{ default_address.int }}
                      </td>
                    </tr>

                    <tr>
                      <td
                        style="width: 50%"
                        class="has-background-light has-text-primary"
                      >
                        <b>Colonia</b>
                      </td>
                      <td>{{ default_address.block }}</td>
                    </tr>

                    <tr>
                      <td
                        style="width: 50%"
                        class="has-background-light has-text-primary"
                      >
                        <b>Delegación o Municipio</b>
                      </td>
                      <td>{{ default_address.suburb }}</td>
                    </tr>

                    <tr>
                      <td
                        style="width: 50%"
                        class="has-background-light has-text-primary"
                      >
                        <b>Estado</b>
                      </td>
                      <td>{{ default_address.city }}</td>
                    </tr>

                    <tr>
                      <td
                        style="width: 50%"
                        class="has-background-light has-text-primary"
                      >
                        <b>Código Postal</b>
                      </td>
                      <td>{{ default_address.postal_code }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>

        <!-- Pickup -->
        <div class="card" v-if="order.shipping_method === 'pickup'">
          <div class="card-content">
            <div class="columns">
              <div class="column is-3 has-background-light">
                <div class="p-5 is-size-5 has-text-centered">
                  <span class="icon"
                    ><i class="mdi mdi-map-marker-down"></i
                  ></span>
                  <span><b>Pick-Up</b></span>
                </div>
              </div>
              <div class="column">
                <table class="table is-fullwidth">
                  <tbody>
                    <tr>
                      <td
                        style="width: 50%"
                        class="has-background-light has-text-primary"
                      >
                        <b>Sucursal</b>
                      </td>
                      <td>
                        <div>
                          <div class="has-text-primary mb-2">
                            <b>CENTRO COMERCIAL INTERLOMAS</b>
                          </div>
                          <span class="icon"
                            ><i class="mdi mdi-map-marker"></i
                          ></span>
                          <span class="has-text-grey"
                            ><b
                              >MOST INTERLOMAS, LOCAL X-05, PLANTA
                              ALTA</b
                            ></span
                          >
                        </div>
                      </td>
                    </tr>

                    <tr>
                      <td
                        style="width: 50%"
                        class="has-background-light has-text-primary"
                      >
                        <b>Instrucciones</b>
                      </td>
                      <td>
                        <b-button
                          type="is-primary"
                          tag="a"
                          href="https://maps.app.goo.gl/8jM6bLd9tU1V8thH7"
                          icon-left="map-search"
                          target="_blank"
                          rel="noopener noreferrer"
                          >VER EN MAPS</b-button
                        >
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
        
        

        <!-- Items -->

        <div class="card">
          <div class="card-content">
            <div class="columns">
              <div class="column is-3 has-background-light">
                <div class="p-5 is-size-5 has-text-centered">
                  <span class="icon"
                    ><i class="mdi mdi-cart-arrow-right"></i
                  ></span>
                  <span><b>Productos</b></span>
                </div>
              </div>
              <div class="column">
                <div
                  v-for="(item, item_index) in order.items"
                  :key="item_index"
                  class="card mb-1"
                >
                  <div class="card-content">
                    <div class="columns is-vcentered">
                      <div class="column has-text-centered-mobile is-1">
                        <media-img
                          :img="item.img"
                          bgsize="contain"
                          size="100x80"
                        ></media-img>
                      </div>
                      <div class="column has-text-centered-mobile is-7">
                        <div class="columns">
                          <div class="column is-1">
                            <span class="tag is-dark">{{ item.quantity }}</span>
                          </div>
                          <div class="column is-11">
                            <b>{{ item.description }}</b>
                          </div>
                        </div>
                      </div>

                      <div class="column has-text-centered-mobile is-2">
                        <div><b>Precio</b></div>
                        <span>{{ item.unitary_price | currency }}</span>
                      </div>

                      <div class="column has-text-centered-mobile is-2">
                        <div><b>Importe</b></div>
                        <span
                          ><b class="has-text-primary">{{
                            item.total | currency
                          }}</b></span
                        >
                      </div>
                    </div>
                  </div>
                </div>

                <!-- ORDER TOTALS -->

                <div class="columns mt-5">
                  <div class="column is-6"></div>
                  <div class="column is-6">
                    <div
                      class="
                        mb-3
                        has-text-primary has-text-right has-text-centered-mobile
                      "
                    >
                      <b
                        >{{ total_items | number }} PRODUCTO{{
                          total_items !== 1 ? "S" : ""
                        }}</b
                      >
                    </div>
                    <table class="table is-narrow is-fullwidth">
                      <tbody>
                        <tr>
                          <td class="has-text-right"><b>SUBTOTAL</b></td>
                          <td class="has-text-right">
                            <b>{{ order.subtotal | currency }}</b>
                          </td>
                        </tr>
                        <tr v-if="order.discount > 0">
                          <td class="has-text-right has-text-danger">
                            <b><b-icon icon="sale"></b-icon> DESCUENTO</b>
                            <span v-if="order.coupon">
                              <span v-if="order.coupon.coupon">
                                <span v-if="order.coupon.coupon.has_discount">
                                  <span
                                    v-if="
                                      order.coupon.coupon.discount_type ===
                                      'relative'
                                    "
                                    >{{
                                      order.coupon.coupon.discount_value
                                        | number
                                    }}%</span
                                  >
                                </span>
                              </span>
                            </span>
                          </td>
                          <td class="has-text-right has-text-danger">
                            <b>- {{ order.discount | currency }}</b>
                          </td>
                        </tr>
                        <tr>
                          <td class="has-text-right">
                            <b>ENVÍO</b>
                            <span
                              class="has-text-danger"
                              v-if="order.coupon.has_free_shipping"
                            >
                              ¡Gratis!
                            </span>
                          </td>
                          <td class="has-text-right">
                            <b>{{ order.shipping | currency }}</b>
                          </td>
                        </tr>
                        <tr>
                          <td class="has-text-right has-text-primary is-size-4">
                            <b>TOTAL</b>
                          </td>
                          <td class="has-text-right has-text-primary is-size-4">
                            <b>{{ order.total | currency }}</b>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Payment -->

        <div class="card">
          <div class="card-content">
            <div class="columns">
              <div class="column is-3 has-background-light">
                <div class="p-5 is-size-5 has-text-centered">
                  <span class="icon"
                    ><i class="mdi mdi-credit-card-multiple-outline"></i
                  ></span>
                  <span><b>Método de Pago</b></span>
                </div>
              </div>
              <div class="column">
                <div class="columns">
                  <div
                    v-if="order.payment_provider === 'bzpay'"
                    class="column is-6"
                  >
                    <div class="columns is-mobile is-vcentered">
                      <div class="column is-3">
                        <img
                          src="/payments/visa-mastercard.png"
                          alt="Visa Mastercard"
                        />
                      </div>
                      <div class="column">
                        <p class="title is-6">VISA Y MASTERCARD</p>
                        <p class="subtitle is-6">
                          Pago con Tarjeta de Crédito o Débito
                        </p>
                      </div>
                    </div>
                  </div>

                  <div
                    v-if="order.payment_provider === 'payclip'"
                    class="column is-6"
                  >
                    <div class="columns is-mobile is-vcentered">
                      <div class="column is-3">
                        <img
                          src="/payments/visa-mastercard-amex.png"
                          alt="Visa Mastercard Amex"
                        />
                      </div>
                      <div class="column">
                        <p class="title is-6">VISA, MASTERCARD y AMEX</p>
                        <p class="subtitle is-6">
                          Pago con Tarjetas de Crédito y Débito.
                        </p>
                      </div>
                    </div>
                  </div>

                  <div
                    v-if="order.payment_provider === 'paypal'"
                    class="column is-6"
                  >
                    <div class="columns is-mobile is-vcentered">
                      <div class="column is-3">
                        <img src="/payments/paypal.png" alt="Paypal" />
                      </div>
                      <div class="column">
                        <p class="title is-6">PAYPAL</p>
                        <p class="subtitle is-6">
                          Pago con tu cuenta de Paypal
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="columns">
                  <div
                    v-if="order.payment_provider === 'mercadopago'"
                    class="column is-6"
                  >
                    <div class="columns is-mobile is-vcentered">
                      <div class="column is-3">
                        <img
                          src="/payments/mercadopago.png"
                          alt="Mercadopago"
                        />
                      </div>
                      <div class="column">
                        <p class="title is-6">Mercadopago</p>
                        <p class="subtitle is-6">
                          Pago con tu cuenta de Mercadopago
                        </p>
                      </div>
                    </div>
                  </div>
                  <div
                    v-if="order.payment_provider === 'spei'"
                    class="column is-6"
                  >
                    <div class="columns is-mobile is-vcentered">
                      <div class="column is-3">
                        <img src="/payments/spei.png" alt="SPEI" />
                      </div>
                      <div class="column">
                        <p class="title is-6">Transferencia</p>
                        <p class="subtitle is-6">
                          Pago directo con transferencia SPEI
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div v-if="isPlacingOrder">
          <b-progress size="is-small"></b-progress>
          <div class="mt-3 has-text-centered">
            <b>GENERANDO TU PEDIDO...</b>
          </div>
        </div>

        <div class="columns is-mobile mt-4">
          <div class="column is-6">
            <b-button
              type="is-dark"
              icon-left="arrow-left-bold"
              :disabled="isPlacingOrder"
              @click="goTo(fill_data_url)"
            >
              CORREGIR
            </b-button>
          </div>
          <div class="column is-6 has-text-right">
            <b-button
              type="is-success"
              icon-right="check-decagram"
              :disabled="isPlacingOrder"
              :loading="isPlacingOrder"
              @click="placeOrder()"
            >
              SÍ, CONFIRMAR
            </b-button>
          </div>
        </div>
      </section>
    </div>
  </section>
</template>

<script>
import AppMappers from "@/store/app-global-mappers";
import CartApi from "@/api/cart";

export default {
  name: "FillData",
  mixins: [AppMappers, CartApi],
  props: ["order_data", "fill_data_url"],
  data() {
    return {
      order: null,
      isSyncing: 0,
      isPlacingOrder: false,
      redirectUrl: "",
    };
  },

  created() {
    this.order = this.order_data;
  },

  computed: {
    total_items() {
      return Object.keys(this.order.items).length;
    },
    default_address() {
      return this.order.addresses[0];
    },
  },

  mounted() {
    let self = this;
    this.$nextTick(() => {
      this.setCartStep("confirmation");
      this.validateCouponCode();
    });
  },

  methods: {
    goTo(path) {
      let self = this;
      self.isSyncing++;
      window.location.replace(path);
    },

    validateCouponCode() {
      let self = this;

      let coupon = this.order.coupon.coupon;

      if (coupon === null) {
        return false;
      }

      let filters = {
        coupon_code: coupon.code,
        holder_email: this.order.holder.email,
      };

      self.isSyncing++;
      this.api_filtered("get_coupon", filters, (response) => {
        self.isSyncing--;

        if (!this.production) {
          console.log(response);
        }

        if (response) {
          // Not found
          if (response.coupon_exists === false) {
            this.$buefy.dialog.alert({
              message: `<b>¡Vaya!</b>. No hemos encontrado un cupón con el código <b>${coupon.code}</b>`,
              type: "is-danger",
              hasIcon: true,
              ariaRole: "alertdialog",
              ariaModal: true,
            });

            self.removeOrderCoupon();
            return false;
          }

          // Is not active or is expired
          if (
            response.is_active === false ||
            response.is_expired === true ||
            response.is_usable === false
          ) {
            this.$buefy.dialog.alert({
              message: `<b>¡Lo sentimos!</b>. No es posible usar el código <b>${coupon.code}</b> para tu pedido.`,
              type: "is-warning",
              hasIcon: true,
              ariaRole: "alertdialog",
              ariaModal: true,
            });

            self.removeOrderCoupon();
            return false;
          }

          // Not minimum purchase amount
          if (self.order.subtotal < response.minimum_purchase_amount) {
            this.$buefy.dialog.alert({
              message: `<b>Agrega más productos para activar el cupón</b>. El código <b>${coupon.code}</b> requiere un monto mínimo de $<b>${response.minimum_purchase_amount}</b> para activarse`,
              type: "is-warning",
              hasIcon: true,
              ariaRole: "alertdialog",
              ariaModal: true,
            });

            self.removeOrderCoupon();
            return false;
          }
        }
      });
    },

    removeOrderCoupon() {
      let self = this;
      self.isSyncing++;
      self.api_post("remove_coupon", null, (response) => {
        self.isSyncing--;
        self.order = response.order;
        self.restoreShippingCost();
      });
    },

    restoreShippingCost() {
      let self = this;
      if (this.store_shipping_details) {
        self.setOrderShipping(this.store_shipping_details.amount);
      }
    },

    setOrderShipping(amount) {
      let self = this;
      self.order.shipping = amount;
      self.isSyncing++;
      self.api_post("set_order_shipping", { amount: amount }, (response) => {
        self.isSyncing--;
        self.order = response.order;
        self.fireCartChange({
          item_count: self.total_items,
          order_subtotal: self.order.subtotal,
          order_total: self.order.total,
        });
      });
    },

    placeOrder() {
      let self = this;
      self.isPlacingOrder = true;

      setTimeout(() => {
        self
          .api_filtered("place_order", self.order, (response) => {
            if (!response) {
              return self.$buefy.dialog.alert(
                "En este momento no se pudo generar tu pedido. Por favor intenta nuevamente o ponte en contacto con nosotros."
              );
            }

            self.redirectUrl = response.url;
            self.api_post("remove_session", null, (result) => {
              self.$storage.clear();
              window.location.replace(self.redirectUrl);
              self.isPlacingOrder = false;
            });
          })
          .catch((error) =>
            self.$buefy.dialog.alert(
              "En este momento no se pudo generar tu pedido. Por favor intenta nuevamente o ponte en contacto con nosotros."
            )
          );
      }, 1500);
    },
  },
  watch: {},
};
</script>